 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_CONTENTS from '@/components/xhtml/03_Contents'
 import XHTML04_PREFACE from '@/components/xhtml/04_Preface'
 import XHTML05_1__INTRO from '@/components/xhtml/05_1__Intro'
 import XHTML06_I__FREAK from '@/components/xhtml/06_I__Freak'
 import XHTML07_2__FROM from '@/components/xhtml/07_2__From'
 import XHTML08_3__STEP from '@/components/xhtml/08_3__Step'
 import XHTML09_4__EXOTI from '@/components/xhtml/09_4__Exoti'
 import XHTML10_II__PROF from '@/components/xhtml/10_II__Prof'
 import XHTML11_5__THE_E from '@/components/xhtml/11_5__The_E'
 import XHTML12_6__ILLUS from '@/components/xhtml/12_6__Illus'
 import XHTML13_7__CANNI from '@/components/xhtml/13_7__Canni'
 import XHTML14_8__RESPE from '@/components/xhtml/14_8__Respe'
 import XHTML15_9__SELF_ from '@/components/xhtml/15_9__Self_'
 import XHTML16_10__CONC from '@/components/xhtml/16_10__Conc'
 import XHTML17_LIST_OF from '@/components/xhtml/17_List_of'
 import XHTML18_NOTES from '@/components/xhtml/18_Notes'
 import XHTML19_REFERENC from '@/components/xhtml/19_Referenc'
 import XHTML20_INDEX from '@/components/xhtml/20_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/03_Contents",
 			"name" : "xhtml/03_Contents",
 			"component" : XHTML03_CONTENTS
 		},
 		{
 			"path" : "/xhtml/04_Preface",
 			"name" : "xhtml/04_Preface",
 			"component" : XHTML04_PREFACE
 		},
 		{
 			"path" : "/xhtml/05_1__Intro",
 			"name" : "xhtml/05_1__Intro",
 			"component" : XHTML05_1__INTRO
 		},
 		{
 			"path" : "/xhtml/06_I__Freak",
 			"name" : "xhtml/06_I__Freak",
 			"component" : XHTML06_I__FREAK
 		},
 		{
 			"path" : "/xhtml/07_2__From",
 			"name" : "xhtml/07_2__From",
 			"component" : XHTML07_2__FROM
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js